import { useCallback, useEffect, useMemo, useState } from "react";
import { Table } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { GLOBALTYPES } from "../redux/actions/globalTypes";
import { getDataAPI, postDataAPI } from "../utils/fetchData";
import Adminnavbar from "./adminnavbar";
import Footer from "./footer";
import LoginRequest from "./loginRequest";
import Sidenavbar from "./sidenav";

const CONTAINER_STYLE = { backgroundColor: "#ffffff", padding: "30px" };
const DASHBOARD_ROW_STYLE = {
	paddingTop: "20px",
	paddingBottom: "20px",
	backgroundColor: "#A7D588",
};
const TABLE_CONTAINER_STYLE = { padding: "10px" };
const ACTION_CELL_STYLE = {
	fontSize: "20px",
	textAlign: "center",
	fontFamily: "Roboto, sans-serif",
};
const DASHBOARD_CARDS = [
	{ key: "active", label: "Active Submissions", bgColor: "#24A2B3" },
	{ key: "total", label: "Total Submissions", bgColor: "#E96CB4" },
];

const ContactusManagement = () => {
	const { auth } = useSelector((state) => state);
	const [contacts, setContacts] = useState([]);
	const [counts, setCounts] = useState({ active: 0, total: 0 });
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);

	const dispatch = useDispatch();

	useEffect(() => {
		const fetchContactsAndCounts = async () => {
			if (!auth.token) return;
			try {
				dispatch({ type: GLOBALTYPES.ALERT, payload: { loading: true } });
				setLoading(true);
				setError(null);
				const [contactsRes, countsRes] = await Promise.all([
					getDataAPI("getcontactus", auth.token),
					getDataAPI("getcountcontactus", auth.token),
				]);
				setContacts(contactsRes.data.contactus || []);
				setCounts(countsRes.data || { active: 0, total: 0 });
			} catch (err) {
				console.error("Error fetching contact us data:", err);
				setError("Failed to load contact us data");
				dispatch({
					type: GLOBALTYPES.ALERT,
					payload: { error: "Failed to fetch contact us data" },
				});
			} finally {
				setLoading(false);
				dispatch({ type: GLOBALTYPES.ALERT, payload: { loading: false } });
			}
		};
		fetchContactsAndCounts();
	}, [auth.token, dispatch]);

	const handleDeleteClick = useCallback(
		async (id) => {
			dispatch({ type: GLOBALTYPES.ALERT, payload: { loading: true } });
			try {
				const res = await postDataAPI("deletecontactus", { id }, auth.token);
				if (res.status === 200) {
					window.location.reload();
				}
			} catch (err) {
				console.error("Error deleting contact:", err);
				dispatch({
					type: GLOBALTYPES.ALERT,
					payload: {
						error: err.response?.data?.msg || "Error deleting contact",
					},
				});
			} finally {
				dispatch({ type: GLOBALTYPES.ALERT, payload: { loading: false } });
			}
		},
		[auth.token, dispatch]
	);

	const dashboardCards = useMemo(() => {
		return DASHBOARD_CARDS.map((card) => (
			<div
				key={card.key}
				className="col text-format"
				style={{ backgroundColor: card.bgColor }}>
				<div className="text1">{counts[card.key] || 0}</div>
				<div className="text1">{card.label}</div>
			</div>
		));
	}, [counts]);

	const contactRows = useMemo(() => {
		if (!contacts.length) {
			return (
				<tr>
					<td colSpan={6} className="text-center">
						No contact us submission
					</td>
				</tr>
			);
		}
		return contacts.map((contact, index) => (
			<tr key={contact.id}>
				<td>{index + 1}</td>
				<td>{contact.name}</td>
				<td>{contact.email}</td>
				<td>{contact.mobile}</td>
				<td>{contact.message}</td>
				<td style={ACTION_CELL_STYLE}>
					<button
						onClick={() => handleDeleteClick(contact.id)}
						className="btn btn-danger bg-danger">
						Delete
					</button>
				</td>
			</tr>
		));
	}, [contacts, handleDeleteClick]);

	if (!auth.user) {
		return <LoginRequest />;
	}

	return (
		<>
			<Adminnavbar />
			<div style={CONTAINER_STYLE}>
				<div className="dashboard-text">Contact Us Management</div>
				<div id="admin">
					<div>
						<div className="row format">
							<Sidenavbar />
							<div className="col-8">
								{loading ? (
									<div className="text-center p-4">
										Loading contact us data...
									</div>
								) : error ? (
									<div className="text-center p-4 text-danger">{error}</div>
								) : (
									<>
										<div className="row format" style={DASHBOARD_ROW_STYLE}>
											{dashboardCards}
										</div>
										<div className="row mt-4" style={TABLE_CONTAINER_STYLE}>
											<div className="col">
												<h4 className="feedbacklist-text">
													Contact Us Submissions
												</h4>
												<Table>
													<thead id="pl">
														<tr>
															<th>S.No</th>
															<th>Name</th>
															<th>Email</th>
															<th>Mobile</th>
															<th>Message</th>
															<th>Action</th>
														</tr>
													</thead>
													<tbody>{contactRows}</tbody>
												</Table>
											</div>
										</div>
									</>
								)}
							</div>
						</div>
					</div>
				</div>
			</div>
			<Footer />
		</>
	);
};

export default ContactusManagement;
